import { useFrontendCore } from "@kosmod/core";
import { ID, useAsync, useLogger } from "@kosmod/kit";
import { Channel, Http, HttpApi } from "@kosmod/pancake";
import { Game, Player, UserState } from "@kosmod/sesame";
import { Theatre, theatreAPI, useTheatreCoreResource } from "@kosmod/theatre";
import { useMemo, useState, useEffect, useRef, h, Component } from "@lukekaalim/act";

import { conciergeApiDef } from "../../defs/api";
import { createRoomSessionClient, RoomSessionChannel } from "../../backend";
import { useConciergeState } from "../../hooks/useConciergeState";
import { useRemoteTheatreController } from "@kosmod/theatre";
import { html } from "@lukekaalim/act-web";
import { ConciergeOverlay } from "../ConciergeOverlay";

export type DemoPageProps = {
  // clients: {
  //   sesame: HttpApi.Handler<"client", typeof sesameAPI>,
  //   concierge: HttpApi.Handler<"client", typeof conciergeApiDef>,
  //   theatre: HttpApi.Handler<"client", typeof theatreAPI>,
  // }
}

export const DemoPage: Component<DemoPageProps> = ({  }) => {
  return 'not ready yet';

  // const { net, api } = useFrontendCore();

  // if (!account)
  //   return 'Not Logged in';


  // const self: Player = useMemo(() => ({
  //   id: ID('player'),
  //   account: account.id,
  //   game: ID('game'),
  //   name: account.username,
  // }), [account])

  // const user: UserState = useMemo(() => ({
  //   type: 'player',
  //   account,
  //   player: self
  // }), [account])


  // const res = useTheatreCoreResource();
  // if (!res)
  //   return 'Loading';

  // const logger = useLogger('ConciergeDemo');

  // const [port, setPort] = useState<Channel.Port.Client<RoomSessionChannel> | null>(null);
  // const sesame = useSesameState();

  // const { result: gamesResponse, reject } = useAsync(() => clients.sesame.games['/'].GET({ gameId: ID('game') }, null, {
  //   authorization: `Bearer ${sesame.authTokenSecret}`
  // }))
  
  // useEffect(() => {
  //   logger.log('Making Connection to', gamesResponse, sesame, reject)

  //   if (!gamesResponse || !sesame.authTokenSecret)
  //     return;

  //   const connection = clients.concierge['room/join'].connect({ game: gamesResponse.games[0].id, room: '', token: sesame.authTokenSecret });

  //   setPort(connection.port);

  //   logger.log('Making Connection to', gamesResponse.games[0].id)

  //   return () => {
  //     connection.disconnect();
  //   }
  // }, [clients.concierge, gamesResponse, reject]);

  // if (!port)
  //   return 'Connecting';

  // const roomClient = useRef(() => createRoomSessionClient(self, port, logger)).get();
  
  // const concierge = useConciergeState(roomClient, self);
  // const [controller, data] = useRemoteTheatreController(DEMO_GAME, roomClient.scene, self);

  // return h(html.div, {
  //   style: { width: '100vw', height: '100vh' }
  // }, [
  //   h(Theatre, { res, controller, data, concierge, client: clients.theatre }),
  //   h(ConciergeOverlay, { state: concierge, user, port, rtcClient: net.rtc }),
  // ]);
};

const DEMO_GAME: Game = {
  id: ID('game'),
  name: 'DEMO GAME',
  owner: ID('account')
}